import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { deletePost } from "../../actions/posts";
import "./post.css"
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/navbar';
import { IoIosAlert } from 'react-icons/io'
import Table from './Table';
import { ToastContainer, toast } from 'react-toastify';

function Post({ setCurrentId, posts }) {
  console.log("POSTDATA12", posts)

  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const addNewPost = () => {
    setCurrentId(null)
    navigate('/addpost')
  }



  const [popupContent, setPopupContent] = useState([])
  const handleDeleteAlert = (post) => {
    setShowAlert(true);
    setPopupContent(post)
  }

  console.log('popup', popupContent.id)
  // console.log('popup123', popupContent)
  useEffect(() => {
    if (showAlert) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showAlert])

  return (
    <div className='' style={{ position: 'relative' }}>
      <Navbar>
        <div exact activeClassName="active" style={{ cursor: 'pointer' }} onClick={addNewPost} className="nav-link">Add New Post</div>
      </Navbar>
      <div style={{ position: 'relative' }}>
        <div className='container'>
          {!posts?.length ? <div className="loading" style={{ paddingBottom: "30px" }}></div> : (
            <div>
              <div className='postContainer'>
                <Table posts={posts} setCurrentId={setCurrentId} handleDeleteAlert={handleDeleteAlert} />
              </div>
            </div>
          )}

          {showAlert && (
            <div className="popupContainer">
              <div className="messageStatusBody" onClick={(e) => e.stopPropagation()}>
                <div className="image">
                  <IoIosAlert className="icon" />
                </div>
                <div className="text">Are you sure you want to delete <span>{popupContent.postername} post?</span></div>
                <div className="popaction">
                  <span onClick={() => setShowAlert(false)} className='span'>No</span>
                  <button className='span delete ' onClick={() => dispatch(deletePost(popupContent.id, setLoading, setShowAlert, toast))} disabled={loading}>{loading ? 'Yes..' : 'Yes'}</button>
                </div>

              </div>
            </div>
          )}
        </div>
        <ToastContainer />
      </div>


    </div>
  )
}


export default Post